import { Component } from '@angular/core';

@Component({
  selector: 'app-background-reports',
  templateUrl: './background-reports.component.html',
  styleUrls: ['./background-reports.component.scss']
})
export class BackgroundReportsComponent {

}
